import axios from 'axios';
import getApiBaseUrl from '../GetServer';

export interface ChangeStatusRequest {
  idUser: number;
  status: number; // 1 para activo, 0 para inactivo
}

export const changeUserStatus = async (requestData: ChangeStatusRequest) => {
  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}dash/change-status-user`;
    
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Token no disponible');

    const response = await axios.post(
      endpoint,
      requestData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error en changeUserStatus:', error);
    
    // Manejo detallado de errores
    if (axios.isAxiosError(error)) {
      const serverError = error.response?.data;
      throw new Error(serverError?.message || 'Error al cambiar el estado del usuario');
    }
    
    throw new Error('Error de conexión');
  }
};